module.exports = __webpack_public_path__ + "static/media/origami16.343eef30.JPG";